import { Strings } from "../shared/strings";

export class MultiWordFilter {

    static matchMode = "containsAllWords";

    static getWords(filter: unknown): string[] {
        return typeof filter == "string" ? filter.trim().split(/\s+/).filter(word => word != "") : [];
    }

    static includes(value: string, filter: unknown): boolean {
        return MultiWordFilter.getWords(filter).every(word => Strings.includesCi(value, word));
    }

}
